import { AxiosResponse } from "axios";
import { DeletePrioritySupplierRequest, PrioritySuppliersRequest } from "@/main/models/request";
import { PrioritySuppliersResponse } from "@/main/models/response/PrioritySuppliersResponse";
import { Result } from "../../models/common/resultResponse";
import { api } from "../base/api";
import { IPrioritySupplierApi } from "../base";

const baseRoute: string = "PrioritySupplier";

export class PrioritySupplierApi extends IPrioritySupplierApi {
	savePrioritySupplier(request: PrioritySuppliersRequest): Promise<AxiosResponse<Result<PrioritySuppliersResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	deletePrioritySupplier(request: DeletePrioritySupplierRequest): Promise<AxiosResponse<Result<any>>> {
		return api.post(`${baseRoute}/delete`, request);
	}
}
